import React from "react";
import InstituteArticleTile from "../../../../components/instituteArticleTile/InstituteArticleTile";
import { instituteArticlesData } from "../../../../instituteArticles/instituteArticlesData";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { ProgressBar, SkeletonText } from "@carbon/react";

export default function InstituteMainPage() {
  const { t } = useTranslation();
  const { instituteArticles, isInstitutePending } = useOutletContext();

  const filteredArticles = instituteArticlesData.filter(item => item.questions);
  const completedCount = filteredArticles.filter((item) =>
    instituteArticles.some(
      (article) =>
        article.name === item.name &&
        article.revision === item.revision &&
        article.completed === true
    )
  ).length;
  const progressPercent =
    filteredArticles.length > 0
      ? Math.ceil((completedCount / filteredArticles.length) * 100)
      : 0;

  return (
    <>
      <div className="main_institute_title">
        <div className="main_institute_title_text">
          <h2>{t("main.institute.pageTitle")}</h2>
          <p>{t("main.institute.pageDesc")}</p>
        </div>
        <div className="main_institute_title_progress">
          {isInstitutePending ? (
            <SkeletonText lineCount={3} className="main_institute_title_progress_ProgressBar" width="312px"/>
          ) : (
            <ProgressBar
              max={100}
              value={progressPercent}
              size="small"
              label={t("main.institute.progress.title")}
              helperText={t("main.institute.progress.desc", {
                percent: progressPercent,
              })}
              className="main_institute_title_progress_ProgressBar"
              status={progressPercent >= 100 ? "finished" : "active"}
            />
          )}
        </div>
      </div>
      <div className="main_institute_articles">
        {instituteArticlesData.map((item) => (
          <InstituteArticleTile
            key={item.id}
            title={item.title}
            desc={item.desc}
            name={item.name}
            instituteArticles={instituteArticles}
            isInstitutePending={isInstitutePending}
          />
        ))}
      </div>
    </>
  );
}
